import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function TermsEthicsPage() {
  return (
    <div>
      <Header/>
      <main
        data-bg-type='white'
        className='wrapper my-[100px] lg:my-[160px]'
      >
        <h1 className='text-title3 font-bold lg:text-display3 text-center'>모듈링크 윤리강령</h1>


        <div className="flex flex-col gap-y-[30px] mt-[120px]">
          <h2 className="text-heading2">제1장 총칙</h2>

          <div>
            <h3 className="text-heading3">제1조(목적)</h3>
            <p>
              이 윤리강령은 모듈링크 구성원 모두가 올바른 가치 판단과 윤리적 행동을 실천하기 위한 기준을 제시함을 목적으로 합니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제2조(적용대상)</h3>
            <p>
              모듈링크에 소속된 모든 구성원은 본 강령을 숙지하고 준수해야 합니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제3조(기본의무)</h3>
            <p>
              구성원은 정직, 책임, 상호존중을 기반으로 행동하며, 윤리적 판단에 따라 업무를 수행합니다.
            </p>
          </div>

          <h2 className="text-heading2">제2장 구성원의 윤리</h2>
          <div>
            <h3 className="text-heading3">제4조(공정한 업무수행)</h3>
            <p>
              모든 업무는 법과 규정을 준수하고, 공정하고 투명하게 수행합니다. 부당한 이익을 취하거나 제3자에게 특혜를 주지 않습니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제5조(이해상충 회피)</h3>
            <p>
              회사의 이익과 충돌되는 사적 이익을 추구하지 않으며, 필요한 경우 이를 즉시 보고하고 회피합니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제6조(금품 수수 금지)</h3>
            <p>
              직무와 관련하여 어떠한 금품이나 향응도 주고받지 않습니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제7조(정보보호)</h3>
            <p>
              업무상 취득한 정보는 회사의 자산으로 간주하며, 승인 없이 외부에 유출하거나 사적으로 이용하지 않습니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제8조(직장 내 존중)</h3>
            <p>
              구성원 간 상호 존중하며, 차별, 괴롭힘, 성희롱 등 비윤리적 언행을 하지 않습니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제9조(근무 태도)</h3>
            <p>
              업무 중에는 사적인 행위를 자제하고, 회사 자산을 개인 용도로 사용하지 않습니다.
            </p>
          </div>

          <h2 className='text-heading2'>제3장 고객 및 외부 관계</h2>
          <div>
            <h3 className="text-heading3">제10조(고객존중 및 보호)</h3>
            <p>
              고객을 존중하고, 고객의 정보를 안전하게 보호하며, 고객 응대는 성실하고 공정하게 합니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제11조(협력사와의 관계)</h3>
            <p>
              협력사와는 공정하고 상호 존중하는 관계를 유지하며, 어떠한 형태의 부당 요구도 하지 않습니다.
            </p>
          </div>

          <h2 className='text-heading2'>제4장 회사의 책무</h2>
          <div>
            <h3 className="text-heading3">제12조(공정한 기회와 평가)</h3>
            <p>
              회사는 구성원의 다양성과 역량을 존중하며, 차별 없는 기회와 공정한 평가를 제공합니다.
            </p>
          </div>
          <div>
            <h3 className="text-heading3">제13조(쾌적한 근무환경)</h3>
            <p>
              회사는 구성원이 안전하고 쾌적하게 일할 수 있는 환경을 조성합니다.
            </p>
          </div>

          <h2 className='text-heading2'>제5장 기타</h2>
          <div>
            <h3 className="text-heading3">제14조(교육 및 운영)</h3>
            <p>
              회사는 윤리경영 실천을 위해 필요한 교육과 가이드를 수시로 제공하며, 윤리강령은 회사의 상황 변화에 따라 개정될 수 있습니다.
            </p>
          </div>
        </div>
      </main>
      <Footer/>
    </div>
  )
}